import React from "react";
import useApi from "../../hooks/useApi";
import ClienteApiClient from "../../api/cliente";
import ClientesDataTable from "./Clientes/ClientesDataTable";
import Card from "../../components/page/Card";
import { AppContext } from "../../contexts/AppContext";
import OptionsSwal from "../../components/Swal/optionsSwal";
import CommonSwal from "../../components/Swal/commonSwal";
import { Cores } from "../../constants/Cores";
import ClienteModal from "./Clientes/ClienteModal";

function Clientes() {
  const [clientes, setClientes] = React.useState([]);
  const [values, setValues] = React.useState({});
  const [clienteModal, setClienteModal] = React.useState(false);
  const { session } = React.useContext(AppContext);
  const [clienteTab, setClienteTab] = React.useState(0);
  const [editar, setEditar] = React.useState(false);
  const [sent, setSent] = React.useState(false);

  const { request: getClientes, data: clientesResponse } = useApi(
    ClienteApiClient.listClientes
  );
  const getClienteApi = useApi(ClienteApiClient.getCliente);
  const deleteClienteApi = useApi(ClienteApiClient.deleteCliente);

  //Busca clientes ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getClientes(session.empresa.replace(/E/gi, ""));
  }, [getClientes, session.empresa]);

  //Define o retorno do backend nos valores das linhas
  React.useEffect(() => {
    if (clientesResponse) setClientes(clientesResponse);
  }, [clientesResponse]);

  const togNovoClienteModal = async () => {
    setValues({});
    setClienteTab(0);
    setEditar(false);
    setClienteModal(true);
    setSent(false);
  };

  const togEditarClienteModal = async (uid) => {
    const response = await getClienteApi.request(
      session.empresa.replace(/E/gi, ""),
      uid
    );
    setValues({ ...response, uid: uid });
    setClienteTab(1);
    setEditar(true);
    setClienteModal(true);
    setSent(false);
  };

  const apagarCliente = (uid) => {
    OptionsSwal({
      title: "Deseja realmente excluir esse cliente?",
      icon: "warning",
      confirmButtonColor: Cores.buttons.azulConfirm,
      denyButtonColor: Cores.buttons.cinzaDeny,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteClienteApi.request(
          session.empresa.replace(/E/gi, ""),
          uid
        );
        if (!response) return;
        CommonSwal({
          icon: "success",
          title: "Cliente excluído com sucesso!",
        });
        await getClientes(session.empresa.replace(/E/gi, ""));
      }
    });
  };

  return (
    <>
      <Card>
        <ClientesDataTable
          clientes={clientes}
          togNovoClienteModal={togNovoClienteModal}
          apagarCliente={apagarCliente}
          togEditarClienteModal={togEditarClienteModal}
        />
      </Card>
      <ClienteModal
        modalHook={{ clienteModal, setClienteModal }}
        valuesHook={{ values, setValues }}
        clienteTabHook={{ clienteTab, setClienteTab }}
        sentHook={{ sent, setSent }}
        editar={editar}
        buscaClientes={(empresa) => {
          getClientes(empresa);
        }}
        togEditarClienteModal={(uid) => {
          togEditarClienteModal(uid);
        }}
      />
    </>
  );
}

export default Clientes;
